/**
 * 工单管理模块（src/views/workOrderManagement）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 * 术语约定：工单=Work Order，报修=Repair Report，投诉=Complaint，派单=Dispatch，
 *          接单=Accept，办结/完结=Completed，回访=Follow-up Visit，超时=Overdue，处理人=Handler
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '编辑': 'Edit',
  '删除': 'Delete',
  '详情': 'Details',
  '更多': 'More',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '操作': 'Action',
  '是': 'Yes',
  '否': 'No',
  '状态': 'Status',
  '备注': 'Remark',
  '导出': 'Export',
  '下载': 'Download',
  '无图片': 'No Image',
  '无文件': 'No File',
  '展开': 'Expand',
  '收起': 'Collapse',
  '已选择 {count} 项': '{count} items selected',
  '确定删除吗?': 'Are you sure you want to delete?',
  '更新时间': 'Updated At',

  // ── 工单查询/列表 ──
  '工单编号': 'Work Order No.',
  '工单类型': 'Work Order Type',
  '工单状态': 'Work Order Status',
  '工单紧急程度': 'Work Order Urgency',
  '当前节点处理人': 'Current Node Handler',
  '工单联系人': 'Work Order Contact',
  '联系电话': 'Contact Phone',
  '申请人': 'Applicant',
  '申请时间': 'Application Time',
  '来源': 'Source',
  '创建人员': 'Creator',
  '微信端游客': 'WeChat Guest',
  '小程序': 'Mini Program',
  '公众号': 'Official Account',
  '确定开启吗?': 'Are you sure to start?',
  '开启': 'On',
  '开启成功': 'Started successfully',
  '签收': 'Claim',
  '签收成功': 'Claimed successfully',
  '取消签收': 'Cancel Claim',
  '取消签收成功': 'Claim cancelled successfully',
  '转办': 'Transfer',
  '转办成功': 'Transferred successfully',
  '委派成功': 'Delegated successfully',
  '接单成功': 'Order accepted successfully',
  '操作成功': 'Operation successful',
  '安装成功': 'Installed successfully',
  '存在必填内容未填！': 'Required fields are missing!',
  '选择人员': 'Select Personnel',
  '选择转办人员': 'Select Transfer Personnel',
  '选择指派人员': 'Select Assignee',
  '选择委派人员': 'Select Delegate Personnel',
  '请选择人员': 'Please select personnel',
  '请选择工单紧急程度': 'Please select work order urgency',
  '请选择工单类型': 'Please select work order type',
  '请选择创建人员': 'Please select creator',
  '请选择处理人员': 'Please select handler',
  '请选择来源': 'Please select source',
  '请选择申请时间': 'Please select application time',
  '请选择更新时间': 'Please select update time',
  '请输入工单编号': 'Please enter work order no.',

  // ── 工单类型枚举 ──
  '换表': 'Meter Replacement',
  '工程报装': 'Engineering Installation',
  '故障报修': 'Fault Repair',
  '水厂报修': 'Water Plant Repair',
  '报停': 'Suspension',
  '复接': 'Reconnection',
  '销户': 'Account Cancellation',
  '用水性质变更': 'Water Use Category Change',

  // ── 工单状态枚举（换表/报停/复接/销户）──
  '新建工单': 'New Work Order',
  '现场处理': 'On-site Handling',
  '大厅审核': 'Service Hall Review',
  '审核': 'Review',
  '归档': 'Archive',
  '已结束': 'Finished',
  '审核工单': 'Work Order Review',
  '旧表审核': 'Old Meter Review',
  '换表登记': 'Meter Replacement Registration',
  '绑定新表': 'Bind New Meter',
  '安装': 'Install',
  '未开启': 'Not Started',

  // ── 工程报装流程状态 ──
  '报装申请': 'Installation Application',
  '报装受理': 'Installation Acceptance',
  '报装勘察设计': 'Installation Survey & Design',
  '报装预算': 'Installation Budget',
  '报装审批': 'Installation Approval',
  '报装收费': 'Installation Fee Collection',
  '报装施工': 'Installation Construction',
  '报装验收': 'Installation Final Acceptance',
  '报装建档': 'Installation Filing',

  // ── 故障报修流程状态 ──
  '生成工单': 'Generate Work Order',
  '处理': 'Handle',
  '指派': 'Assign',
  '待指派': 'Pending Dispatch',
  '报修中': 'Repairing',
  '等待评价': 'Awaiting Evaluation',
  '结束': 'Finished',
  '查看评价': 'View Evaluation',
  '评价': 'Evaluation',

  // ── 故障报修（faultRepairReport）──
  '报修人名称': 'Reporter Name',
  '报修人': 'Reporter',
  '报修人电话': 'Reporter Phone',
  '报修户地址': 'Reporter Address',
  '精确地址': 'Exact Address',
  '情况描述': 'Situation Description',
  '报修时间': 'Report Time',
  '报修描述': 'Repair Description',
  '报修信息': 'Repair Report Info',
  '报修指派': 'Repair Dispatch',
  '报修处理': 'Repair Handling',
  '报修修理描述': 'Repair Description',
  '指派和处理信息': 'Dispatch and Handling Info',
  '处理人类型': 'Handler Type',
  '指定人员': 'Assign Personnel',
  '指定班组': 'Assign Team',
  '处理人员选择': 'Select Handler',
  '处理人电话': 'Handler Phone',
  '处理班组选择': 'Select Handler Team',
  '请输入报修人名称': 'Please enter reporter name',
  '请输入备注': 'Please enter remark',
  '请输入报修修理描述': 'Please enter repair description',
  '请输入处理人电话': 'Please enter handler phone',
  '请输入备注信息': 'Please enter remark',
  '请输入处理描述': 'Please enter handling description',
  '请输入投诉处理人联系方式': 'Please enter complaint handler contact',
  '请输入正确的手机号码': 'Please enter a valid mobile phone number',
  '请选择处理人类型': 'Please select handler type',
  '请选择处理班组': 'Please select handler team',
  '请选择班组': 'Please select team',
  '评分等级': 'Rating Level',
  '评分描述': 'Rating Description',

  // ── 处理人员 / 处理班组（hanlderProcessing）──
  '人员姓名': 'Personnel Name',
  '人员电话': 'Personnel Phone',
  '账号': 'Account',
  '班组名称': 'Team Name',
  '班组介绍': 'Team Introduction',
  '组长名称': 'Team Leader Name',
  '组长联系方式': 'Team Leader Contact',
  '组员选择': 'Select Team Members',
  '组员姓名': 'Team Member Name',
  '组员电话': 'Team Member Phone',
  '全部用户': 'All Users',
  '已选用户': 'Selected Users',
  '请输入人员姓名': 'Please enter personnel name',
  '请输入班组名称': 'Please enter team name',
  '请输入班组介绍': 'Please enter team description',
  '请输入组长联系方式': 'Please enter team leader contact',
  '请选择组长': 'Please select team leader',
  '请至少选择一个组员': 'Please select at least one team member',

  // ── 首页看板（home）──
  '待办事项': 'To-do Items',
  '已办事项': 'Completed Items',
  '事项完成率': 'Item Completion Rate',
  '这是待办事项': 'This is the to-do count',
  '这是已办事项': 'This is the completed count',
  '这是事项完成率': 'This is the item completion rate',
  '业务类别占比': 'Business Category Percentage',
  '近一周': 'Last 7 Days',
  '近一月': 'Last Month',
  '近一年': 'Last Year',
  '工单统计': 'Work Order Statistics',
  '工单来源': 'Work Order Source',
  '工单': 'Work Order',
  '部门工单处理情况': 'Department Work Order Handling',
  '工单总数': 'Total Work Orders',
  '已完成': 'Completed',
  '未完成': 'Unfinished',
  '超时未完成': 'Overdue & Unfinished',
  '工单完成率': 'Work Order Completion Rate',
  '派单数': 'Dispatch Count',
  '完成数': 'Completed Count',
  '及时率(%)': 'Timeliness Rate (%)',
  '微信公众号': 'WeChat Official Account',

  // ── 工单评价（WorkOrderEvaluation）──
  '是否已评价': 'Evaluated',
  '请选择是否已评价': 'Please select whether evaluated',

  // ── 审批流（flowable）──
  '审批历史': 'Approval History',
  '流程图': 'Flow Chart',
  '流程审批进度历史': 'Approval Progress History',
  '流程实例ID不存在': 'Process instance ID does not exist',
  '待办中。。。': 'Pending...',
  '实际办理人：': 'Actual Handler: ',
  '接收时间：': 'Received At: ',
  '办结时间:': 'Completion Time: ',
  '办结时间：': 'Completion Time: ',
  '【会签中】': '[Countersigning]',
  '通过:': 'Approved: ',
  '通过：': 'Approved: ',
  '退回:': 'Returned: ',
  '退回：': 'Returned: ',
  '驳回': 'Reject',
  '驳回:': 'Rejected: ',
  '驳回：': 'Rejected: ',
}
